export enum ViewMode {
  NEW,
  EDIT,
  READ_ONLY
}
